/**
 * Every key the app writes is namespaced, so Thrive never collides with anything else on the
 * origin and a future migration can find its own data (architecture §18).
 */
export const STORAGE_NAMESPACE = 'thrive.v1';

/**
 * A record that fails validation leaves a *diagnostic* here — never a copy of the payload.
 * Moving untrusted bytes to a second key is not a recovery strategy when the thing that might
 * be wrong with them is that they contain camera frames or landmarks (architecture §19).
 * Live reads and migrations skip this prefix.
 */
export const QUARANTINE_PREFIX = `${STORAGE_NAMESPACE}.quarantine.`;

export const STORAGE_KEYS = {
  meta: `${STORAGE_NAMESPACE}.meta`,
  family: `${STORAGE_NAMESPACE}.family`,
  children: `${STORAGE_NAMESPACE}.children`,
  progress: `${STORAGE_NAMESPACE}.progress`,
  sessions: `${STORAGE_NAMESPACE}.sessions`,
  sessionSummaries: `${STORAGE_NAMESPACE}.session-summaries`,
  skillEvidence: `${STORAGE_NAMESPACE}.skill-evidence`,
  skillEstimates: `${STORAGE_NAMESPACE}.skill-estimates`,
  /** The one in-flight mission snapshot (PRO-03). Cleared when a mission finishes. */
  missionProgress: `${STORAGE_NAMESPACE}.mission-progress`,
  /**
   * Who launched the in-flight sitting (D-054(2)). Identity only — never preferences — and
   * cleared wherever the mission snapshot is cleared, because the two describe one sitting.
   */
  launchIdentity: `${STORAGE_NAMESPACE}.launch-identity`,
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

/** Composite key for per-player, per-game progress. */
export function progressKey(playerId: string, gameId: string): string {
  return `${playerId}::${gameId}`;
}
